export const ADD_HELD_ORDER = "ADD_HELD_ORDER"
export const DELETE_ALL_HELD_ORDERS = "DELETE_ALL_HELD_ORDERS"
export const DELETE_HELD_ORDER = "DELETE_HELD_ORDER"